import { Component, inject } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { BodenformNachschlagenService } from '../../help/bodenform-nachschlagen.service';
import { hatHumusForm, hatVegetationsformengruppe, klimastufeAnzeige, trackByIndex } from 'src/app/data-model';
import { feinbodenformFilter, hauptbodenformFilter } from 'src/app/data.service';
import { MOOR_FBF_REGEX, MOOR_FBF_REGEX_MELDUNG, MOOR_HBFS, hbfAusMoorFbf, moorFbfVorschlaegeFuer } from 'src/app/bohrpunkte/moor-bodenform';
import { filzVersatz } from '../../filz-tiefen';

@Component({
    standalone: false,
    selector: '',
    templateUrl: './boden.component.html',
    styleUrls: ['./hl-area.component.css'],
    
})
export class BodenComponent extends HlAreaComponent {
  trackByIndex = trackByIndex;
  /** Katalog- und Listenknopf an den Bodenform-Feldern. */
  protected readonly nachschlagen = inject(BodenformNachschlagenService);

	hauptbodenformFilter = hauptbodenformFilter;
  feinbodenformFilter = feinbodenformFilter;
  moorFBFRegex = MOOR_FBF_REGEX;
  moorFBFRegexMessage = MOOR_FBF_REGEX_MELDUNG;
  moorHBFSuggestions = [...MOOR_HBFS];
  moorFBFSuggestionsFor = moorFbfVorschlaegeFuer;
  /**
   * Moor-Feinbodenformen stehen in keiner Liste, aus der sich die Hauptbodenform
   * ablesen liesse — sie ergibt sich aus dem Wert selbst (moor-bodenform.ts).
   */
  hbfAusMoorFbf = hbfAusMoorFbf;
	hatHumusForm = hatHumusForm;
	hatVegetationsformengruppe = hatVegetationsformengruppe;
	klimastufeAnzeige = klimastufeAnzeige;

	/** Bei einem Filz die Auflage in cm: Die Spiegeltiefe zählt dann ab Oberkante Ol (flur-tiefe.ts). */
	filzVersatz(): number {
		return filzVersatz(this.data);
	}

  addBodenformPair() {
    this.data.header.bodenform.bf.push({ trenner: '/', hbf: '', fbf: ''});
  }

  removeBodenformPair() {
    this.data.header.bodenform.bf.pop();
  }

  canAddBodenformPair() {
    const bf = this.data.header.bodenform.bf;
    const l = bf.length;
    return l > 0 && l < 3 && (bf[l-1].hbf || bf[l-1].fbf);
  }
}
